import { memo, useEffect } from 'react';
import { default as ReactGA4 } from 'react-ga4';
import { useLocation } from 'react-use';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { isMiniappSelector } from 'src/selectors/app';
import { UrlUtils } from 'src/utils';
import { Element } from 'src/components';
import styles from './style.module.scss';

const ZaloButton = (props: any) => {
    const location = useLocation();
    const { children, className, link, title, hide, ...btnProps } = props;
    const isMiniapp = useSelector(isMiniappSelector);

    useEffect(() => {
        if ((window as any)?.ZaloSocialSDK) {
            setTimeout(() => {
                (window as any)?.ZaloSocialSDK.reload();
            }, 100);
        }
    }, [location]);

    const handleClick = () => {
        ReactGA4.event({
            category: 'mobile_zalo',
            action: 'share',
            label: title,
        });

        if (isMiniapp) {
            window.parent.postMessage(
                {
                    type: 'SHARE_LINK_FROM_BAOMOI',
                    url: UrlUtils.buildZaloShareLink(link),
                },
                'https://h5.zdn.vn'
            );
        }

        if (hide) {
            setTimeout(() => hide(), 300);
        }
    };

    if (isMiniapp) {
        return (
            <Element
                renderAs="a"
                title="Chia sẻ qua Zalo"
                role="button"
                className={cn(className, styles['zalo-share-btn'])}
                data-href={UrlUtils.buildZaloShareLink(link)}
                onClick={handleClick}
                {...btnProps}
            >
                {children}
            </Element>
        );
    }

    return null;

    return (
        <Element
            renderAs="a"
            title="Chia sẻ qua Zalo"
            role="button"
            className={cn(
                className,
                styles['zalo-share-btn'],
                'zalo-share-button'
            )}
            data-href={UrlUtils.buildZaloShareLink(link)}
            data-oaid="3128995559321116723"
            data-layout="2"
            data-customize="true"
            data-color="blue"
            onClick={handleClick}
            {...btnProps}
        >
            {children}
        </Element>
    );
};

export default memo(ZaloButton);
